var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.314,
    height: 77.444,
    viewBox: "0 0 82.314 77.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4958",
    "data-name": "Group 4958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8010",
    "data-name": "Path 8010",
    d: "M27.433,5.921H5.99V25.532h0A36.575,36.575,0,0,1,24.936,6.988l2.5-1.067Z",
    transform: "translate(-3.454 -3.424)",
    fill: "#ffbf00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_311",
    "data-name": "Ellipse 311",
    cx: 19.514,
    cy: 20.415,
    rx: 19.514,
    ry: 20.415,
    transform: "translate(34.602 27.842)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8011",
    "data-name": "Path 8011",
    d: "M126.549,113.707l7.122,7.45a2.79,2.79,0,0,1,0,3.82h0a2.5,2.5,0,0,1-3.651,0l-7.121-7.45",
    transform: "translate(-54.322 -50.323)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8012",
    "data-name": "Path 8012",
    d: "M111.633,115.99a22.948,22.948,0,0,0,13.447-14.067",
    transform: "translate(-49.421 -45.196)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8013",
    "data-name": "Path 8013",
    d: "M88,74.547a5.253,5.253,0,1,1,7.982,4.489A5.592,5.592,0,0,0,93.255,83.8v.9",
    transform: "translate(-39.139 -30.999)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8014",
    "data-name": "Path 8014",
    d: "M97.961,102.889a1.166,1.166,0,1,1-1.166-1.166A1.166,1.166,0,0,1,97.961,102.889Z",
    transform: "translate(-42.678 -45.109)",
    fill: "#344154"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1082",
    "data-name": "Line 1082",
    x1: 24.039,
    transform: "translate(13.366 27.842)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1083",
    "data-name": "Line 1083",
    x1: 18.665,
    transform: "translate(13.177 34.575)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1084",
    "data-name": "Line 1084",
    x1: 24.039,
    transform: "translate(13.366 21.109)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8015",
    "data-name": "Path 8015",
    d: "M40.916,115.118H9.193v-5.306",
    transform: "translate(-4.847 -48.628)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8016",
    "data-name": "Path 8016",
    d: "M91.38,10.5h5.306V25.676",
    transform: "translate(-40.608 -5.416)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8017",
    "data-name": "Path 8017",
    d: "M81.265,23.608V1.5H68.134",
    transform: "translate(-30.494 -1.5)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8018",
    "data-name": "Path 8018",
    d: "M39.14,1.5H1.5V62.684H34.34",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.95c607f5aac0a5ef79090a7ebedb3706.svg";
export { ForwardRef as ReactComponent };